<template>
  <div ref="wm" class="security-watermark" aria-hidden="true"></div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SecurityWatermark',
  computed: {
    ...mapState({ user: function (s) { return s.user.user } }),
    label: function () {
      const u = this.user || {}
      const id = u.members_id || 'guest'
      const seq = u.members_seq != null ? u.members_seq : ''
      const t = new Date().toISOString().slice(0, 19).replace('T', ' ')
      return id + ' #' + seq + ' ' + t
    },
  },
  mounted: function () {
    this.render()
    this.timer = setInterval(this.render, 30000)
    window.addEventListener('resize', this.render)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
    window.removeEventListener('resize', this.render)
  },
  methods: {
    escape: function (s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      })
    },
    render: function () {
      const text = this.escape(this.label)
      const w = 320
      const h = 160
      const svg =
        "<svg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'>" +
        "<g transform='rotate(-25 " + (w / 2) + ' ' + (h / 2) + ")'>" +
        "<text x='" + (w / 2) + "' y='" + (h / 2) + "' text-anchor='middle' " +
        "fill='rgba(255,255,255,0.07)' font-size='14' font-family='monospace'>" +
        text + '</text></g></svg>'
      const url = 'data:image/svg+xml;utf8,' + encodeURIComponent(svg)
      if (this.$refs.wm) this.$refs.wm.style.backgroundImage = "url('" + url + "')"
    },
  },
}
</script>

<style scoped>
.security-watermark {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
  z-index: 9999;
  background-repeat: repeat;
  background-size: 320px 160px;
  user-select: none;
}
</style>
